/*============================================================================
  PDP shipping estimate
  ----------------------------------------------------------------------------
  Shows the *marginal* shipping cost of adding the current bike, given what is
  already in the cart. Shipping is weight-banded per delivery profile and the
  charge for a profile is set by the combined weight of items in that profile,
  so adding a second bike may cost less than the first (it shares a band).

  Bands and profile logic live in assets/shipping-tables.js (window.BiriaShipping).
==============================================================================*/
(function () {
  if (window.__pdpShippingEstimateInit) return;
  window.__pdpShippingEstimateInit = true;

  // This script is injected inside the price row, so the variant JSON and the
  // variant inputs (further down the section) aren't in the DOM yet. Defer.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {

  var S = window.BiriaShipping;
  if (!S) return;
  var LB_PER_GRAM = S.LB_PER_GRAM;
  var profileForType = S.profileForType;
  var rate = S.rate;

  function money(n) {
    var s = Math.round(n).toFixed(0);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/, ',');
  }

  var root = document.querySelector('.product-section.pdp2');
  if (!root) return;

  var profile = profileForType(root.getAttribute('data-product-type') || '');

  var variants = [];
  try {
    var vj = root.querySelector('[data-variant-json]');
    variants = vj ? JSON.parse(vj.textContent || '[]') : [];
  } catch (e) {}

  // Authoritative variant id -> grams map (the storefront variant JSON omits grams).
  var weightsById = {};
  try {
    var we = root.querySelector('[data-variant-weights]');
    weightsById = we ? JSON.parse(we.textContent || '{}') : {};
  } catch (e) {}

  // Resolve the selected variant the same way the sticky cart does.
  function currentVariant() {
    var sel = [];
    root.querySelectorAll('[data-variant-input]:checked').forEach(function (i) {
      if (i.value) sel.push(i.value);
    });
    if (sel.length) {
      for (var n = 0; n < variants.length; n++) {
        if ((variants[n].options || []).join('~~') === sel.join('~~')) return variants[n];
      }
    }
    for (var k = 0; k < variants.length; k++) { if (variants[k].available) return variants[k]; }
    return variants[0] || null;
  }

  function currentGrams() {
    var v = currentVariant();
    if (!v) return 0;
    return weightsById[v.id] || v.grams || 0;
  }

  var existingProfileGrams = 0; // weight already in the cart for this profile

  function recompute() {
    var thisGrams = currentGrams();
    var existingLb = existingProfileGrams * LB_PER_GRAM;
    var marginal;
    if (thisGrams > 0) {
      var thisLb = thisGrams * LB_PER_GRAM;
      marginal = rate(profile, existingLb + thisLb) - rate(profile, existingLb);
    } else {
      // Weight not set on this product (these weight-banded profiles need it in
      // Shopify). Fall back to the profile's base band so we still show a price.
      var bands = S.PROFILES[profile];
      marginal = bands ? bands[0].price : 0;
    }
    var text = marginal > 0 ? '+ ' + money(marginal) + ' item shipping' : 'No added shipping';
    document.querySelectorAll('[data-shipping-estimate]').forEach(function (el) {
      el.textContent = text;
      el.hidden = false;
    });
  }

  function readCart(cart) {
    existingProfileGrams = 0;
    var items = (cart && cart.items) || [];
    items.forEach(function (it) {
      if (profileForType(it.product_type) === profile) {
        existingProfileGrams += (it.grams || 0) * (it.quantity || 1);
      }
    });
    recompute();
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(readCart)
      .catch(function () { recompute(); });
  }

  recompute();   // first paint with an empty cart assumption
  fetchCart();   // then refine once the real cart loads

  // Keep in sync with cart and variant changes.
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) readCart(e.detail.cart); else fetchCart();
  });
  document.addEventListener('cart:build', fetchCart);
  document.addEventListener('ajaxProduct:added', fetchCart);
  root.addEventListener('variantChange', recompute);
  document.addEventListener('variant:change', recompute);

  } // end init
})();
